const spookyLabelsByNavigationLabel: Record<string, string> = {
    'Create Tenant': 'Summon Tenant',
    'Create Customer': 'Summon Customer',
    'Terminations': 'Graveyard',
    'DB Backups': 'Crypt Backups',
    'Data Exports': 'Exhumations',
    'Activity Logs': 'Haunting Logs',
    'Contact': 'Séance',
    'Logout': 'Flee',
};

export function spookyNavigationLabel(label: string): string {
    return spookyLabelsByNavigationLabel[label] ?? label;
}
